/**
 * @generated SignedSource<<ababc0b58384dc57875f68feca5859ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PlansCategoriesQuery$variables = {
  categoryId: string;
  channel: string;
};
export type PlansCategoriesQuery$data = {
  readonly eligibleProductOffersByCategory: {
    readonly category: {
      readonly isCategoryContainer: boolean;
      readonly subCategories: ReadonlyArray<{
        readonly defaultSelected: boolean | null;
        readonly id: string;
        readonly name: string;
        readonly visibility: boolean | null;
      }> | null;
    };
    readonly code: number;
    readonly message: string;
  };
};
export type PlansCategoriesQuery = {
  response: PlansCategoriesQuery$data;
  variables: PlansCategoriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "channel"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "categoryId",
        "variableName": "categoryId"
      },
      {
        "kind": "Variable",
        "name": "channel",
        "variableName": "channel"
      }
    ],
    "concreteType": "EligibleProductOffersByCategoryResponse",
    "kind": "LinkedField",
    "name": "eligibleProductOffersByCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CategoryDetail",
        "kind": "LinkedField",
        "name": "category",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCategoryContainer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductDetailsSubCategory",
            "kind": "LinkedField",
            "name": "subCategories",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibility",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultSelected",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PlansCategoriesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PlansCategoriesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a7be4ed7afbe18ef13da423b6a132ed5",
    "id": null,
    "metadata": {},
    "name": "PlansCategoriesQuery",
    "operationKind": "query",
    "text": "query PlansCategoriesQuery(\n  $categoryId: String!\n  $channel: String!\n) {\n  eligibleProductOffersByCategory(categoryId: $categoryId, channel: $channel) {\n    code\n    message\n    category {\n      isCategoryContainer\n      subCategories {\n        id\n        name\n        visibility\n        defaultSelected\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bbf53264fe6bafb8c40e9e5a579b409c";

export default node;
